const styles = {
  modal: {
    borderRadius: 3,
    backgroundColor: 'white',
    padding: 5,
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    maxHeight: 'calc(100vh - 80px)',
    overflow: 'hidden',
    boxSizing: 'border-box',
  },
  closeButton: {
    position: 'absolute',
    top: 8,
    right: 8,
    zIndex: 1,
  },
  scrollableContent: {
    overflowY: 'auto',
    flex: 1,
    minHeight: 0,
  },
  headerLabel: {
    marginBottom: 3,
  },
  formError: {
    marginBottom: 3,
  },
  textField: {
    marginBottom: 2,
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: 2,
    paddingTop: 3,
  },
  cancelButton: {
    marginRight: 3,
  },
  progress: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 1,
    marginBottom: 2,
  },
  progressLabel: {
    color: 'text.secondary',
  },
  secondaryButton: {
    backgroundColor: 'gray',
    padding: 10,
    margin: 5,
  },
  feedback: {
    marginBottom: 2,
  },
  summary: {
    marginBottom: 2,
  },
  summaryStats: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 3,
    marginBottom: 2,
  },
  summaryTableLabel: {
    marginBottom: 1,
  },
  summaryTableWrapper: {
    marginBottom: 2,
  },
  // Deliberately distinct from summaryStats above: these tiles need per-value color (error/warn)
  // to flag counts that need attention, which a shared flat text row can't express. Not meant as
  // a second general-purpose "counts summary" pattern — future stat displays needing emphasis
  // should reuse these, plain ones should reuse summaryStats.
  statRow: {
    display: 'flex',
    gap: 4,
    marginBottom: 3,
    flexWrap: 'wrap',
  },
  statTile: {
    minWidth: 100,
  },
  statTileValue: {
    fontWeight: 500,
  },
  statTileValueWarn: {
    fontWeight: 500,
    color: 'warning.main',
  },
  statTileValueError: {
    fontWeight: 500,
    color: 'error.main',
  },
}

export default styles
